import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { getData, patchData } from "src/utils/axios/serverHelper";
import { formatDate } from "src/utils/string/stringUtil";
import { PRD4011_R01Filter } from "./Store_PRD4011_R01";
import { PRD4011_R01Dto, PRD4011_R01PlcStatusDto } from "./Dto_PRD4011_R01";

const baseUrl = `${config.apiUrl}/PRD4011_R01`;

export const getPRD4011_R01List = async (
    option: string,
    filter: Partial<PRD4011_R01Filter>
) => {
    const url = `${baseUrl}/${option}`;
    const params = {
        compCd: filter.compCd || undefined,
        searchDate: filter.searchDate
            ? formatDate(filter.searchDate)
            : undefined,
    };
    return await getData<ResponseDto<PRD4011_R01Dto>>(url, { params });
};

export const getLatestPRD4011_R01 = async (compCd?: string) => {
    const url = `${baseUrl}/latest`;
    return await getData<ResponseDto<PRD4011_R01Dto>>(url, {
        params: { compCd: compCd || undefined },
    });
};

/** 에러 알림 확인 — MESSAGE_SRC.ref02(최종알림확인시간)를 현재시각으로 기록 */
export const patchPRD4011_R01Alarm = async (data: PRD4011_R01PlcStatusDto) => {
    return await patchData<PRD4011_R01PlcStatusDto, ResponseDto<PRD4011_R01PlcStatusDto>>(
        `${baseUrl}/alarm`,
        data
    );
};
